import { useQuery } from '@tanstack/react-query';
import {
  getPageMovementForDomain,
  PageMovementMode,
  PageMovementResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

const GET_PAGE_MOVEMENT_FOR_DOMAIN = 'page-movement-for-domain';

export const useGetPageMovementForDomain = (
  projectId: number,
  domain: string,
  mode: PageMovementMode,
  page: number,
  pageSize: number,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const { data, isLoading } = useQuery<PageMovementResponse>({
    queryKey: [
      GET_PAGE_MOVEMENT_FOR_DOMAIN,
      projectId,
      domain,
      mode,
      page,
      pageSize,
      chatType,
      fromTimestamp,
      toTimestamp,
      monitorPromptIds,
      filterMonitorTypes,
    ],
    queryFn: () =>
      getPageMovementForDomain(
        projectId,
        domain,
        mode,
        page,
        pageSize,
        chatType!,
        from,
        to,
        monitorPromptIds,
        filterMonitorTypes
      ),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    pageMovement: queryEnabled ? data ?? null : null,
    isLoading: queryEnabled ? isLoading : false,
  };
};
